import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import DropDownList from 'react-widgets/lib/DropdownList';
import moment from 'moment';
import _ from 'lodash';

const TODAY = moment(new Date());
/* NOTE: based on first time entry in the database */
const FIRST_DAY_API = moment('2018-02-01');
/* Calculating number of months between now and first date */
const numberMonthDiff = TODAY.diff(FIRST_DAY_API, 'month', true);

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,

  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
});
/* eslint-enable react/no-unused-prop-types */

const MonthYearFilter = (props) => {
  const buildMonthYearData = () => {
    const dateList = [];

    /* eslint-disable no-plusplus */
    /* Creating a front side list of months */
    for (let i = 0; i < numberMonthDiff; i++) {
      const newDate = moment(FIRST_DAY_API).add(i, 'months');
      dateList.push({
        id: i,
        display: newDate.format('MMM YYYY'),
        apiDate: newDate.format('YYYY-MM-DD'),
      });
    }

    return _.orderBy(dateList, ['id'], ['desc']);
  };


  const { value, onChange } = props;
  return (
    <DropDownList
      inputProps={{
        className: 'form-control',
      }}
      value={value}
      onChange={onChange}
      data={buildMonthYearData()}
      valueField="id"
      textField="display"
    />
  );
};


MonthYearFilter.propTypes = propTypes;


export default MonthYearFilter;
